import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  max-width: 80%;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 21px;
  margin-left: 28px;
  margin-bottom: 12px;
`;

const BubbleContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 12px 16px;
  background: #f0f3f6;
  border-radius: 12px 12px 12px 0px;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const MessageText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  color: #0f0b28;
  word-break: break-word;
`;

const TimestampContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  margin-left: 4px;
`;

const TimestampText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #75818f;
`;

const DoctorImage = styled.img`
  border: 0.5px solid #e3e3e3;
  border-radius: 12px;
  height: 16px;
  width: 16px;
  margin-left: 20px;
`;

const DoctorMessage = ({ message, doctorImage, doctorName, timestamp }) => (
  <div className="flex flex-col">
    <OuterContainer>
      <BubbleContainer>
        <MessageContainer>
          <MessageText>{message}</MessageText>
        </MessageContainer>
      </BubbleContainer>
    </OuterContainer>
    <div className="flex self-start">
      <DoctorImage src={doctorImage} />
      {timestamp && (
        <TimestampContainer>
          <TimestampText>
            {new Date(timestamp).toLocaleTimeString('nu', {
              hour: 'numeric',
              minute: '2-digit',
            })}
          </TimestampText>
        </TimestampContainer>
      )}
    </div>
  </div>
);

DoctorMessage.propTypes = {
  doctorName: PropTypes.string,
  doctorImage: PropTypes.string,
  message: PropTypes.string,
  timestamp: PropTypes.number,
};

export default DoctorMessage;
